import "@arco-design/web-react/es/Trigger/style";
import _Trigger from "@arco-design/web-react/es/Trigger";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import _IconTool from "@arco-design/web-react/icon/react-icon/IconTool";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import { intl, setLocale } from 'di18n-react';
import { useContext, useEffect, useRef, useState } from 'react';
import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalContext } from '@/context';
import Settings from '../Settings';
import styles from './style/index.module.less';
import useStorage from '@/utils/useStorage';
import { generatePermission } from '@/routes';
import { EnvService } from '@/service/services/EnvService';
import Upload from './Upload';
import { useRequest } from 'ahooks';
import Pwd from './Password';
import KeyModal from './KeyModal';
import IconButton from './IconButton';
function Navbar({
  show
}) {
  const userInfo = useSelector(state => state.userInfo);
  const dispatch = useDispatch();
  const [version, setVersion] = useState('');
  const [_, setUserStatus, removeUserStatus] = useStorage('nms_userStatus');
  const [role, setRole] = useStorage('userRole', 'admin');
  const [userName,, removeUserName] = useStorage('nms_userName');
  const [_token, setToken, removeToken] = useStorage('nms_token');
  const [visible, setVisible] = useState(false);
  const [ketVisible, setKetVisible] = useState(false);
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);
  const [logoModalVisible, setLogoModalVisible] = useState(false);
  const [logo, setLogo] = useState(null);
  const [showLogo, setShowLogo] = useState(true);
  const clickCountRef = useRef(0); // 用于存储点击次数
  const timerRef = useRef(null); // 用于存储计时器

  function changeLang(key) {
    setLocale(key, {
      cookieLocaleKey: 'lang'
    });
  }
  const handleTripleClick = () => {
    setLogoModalVisible(true);
  };
  const handleClick = () => {
    clickCountRef.current += 1; // 增加点击计数

    if (timerRef.current) {
      clearTimeout(timerRef.current); // 清除现有的计时器
    }

    // 设置新的计时器，在指定时间内检查点击次数
    timerRef.current = setTimeout(() => {
      if (clickCountRef.current === 3) {
        handleTripleClick(); // 当点击次数为3时触发三击事件
      }
      clickCountRef.current = 0; // 重置点击计数器
    }, 400); // 400毫秒内检测三击事件（可以根据需要调整）
  };
  function logout() {
    localStorage.removeItem('nms_token');
    localStorage.removeItem('nms_userName');
    localStorage.removeItem('nms_userStatus');
    window.location.href = '/nms/login';
  }
  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    }
    if (key === 'key') {
      setKetVisible(true);
    }
    if (key === 'pwd') {
      setVisible(true);
    }
  }
  const {
    run: getResourceQueryRun,
    loading: getResourceQueryLoading
  } = useRequest(EnvService.getResourceQuery, {
    manual: true,
    onSuccess: res => {
      setShowLogo(res.enable);
      setLogo(res.logo + '?t=' + new Date().getTime());
    }
  });
  useEffect(() => {
    getResourceQueryRun();
    EnvService.getAbout().then(res => {
      setVersion(res.version);
    });
    loader.config({
      monaco
    });
  }, []);
  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: {
          ...userInfo,
          permissions: generatePermission(role)
        }
      }
    });
  }, [role]);
  if (!show) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['fixed-settings']
    }, /*#__PURE__*/React.createElement(Settings, {
      trigger: /*#__PURE__*/React.createElement(_Button, {
        icon: /*#__PURE__*/React.createElement(_IconSettings, null),
        type: "primary",
        size: "large"
      })
    }));
  }
  const handleChangeRole = () => {
    const newRole = role === 'admin' ? 'user' : 'admin';
    setRole(newRole);
  };
  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick,
    className: styles.dropDownList
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "key",
    style: {
      height: '36px',
      lineHeight: '36px',
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(_IconTool, {
    className: styles['dropdown-icon']
  }), intl.t('AccessKey管理')), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "pwd",
    style: {
      height: '36px',
      lineHeight: '36px',
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(_IconLock, {
    className: styles['dropdown-icon']
  }), intl.t('修改密码')), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout",
    style: {
      height: '36px',
      lineHeight: '36px',
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles['dropdown-icon']
  }), intl.t('退出登录')));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, logo && showLogo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    style: {
      height: 40
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 40,
      fontSize: 30,
      marginLeft: 15
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: logo && showLogo ? 12 : 0,
      color: '#fff',
      cursor: 'pointer',
      userSelect: 'none'
    },
    onClick: () => {
      handleClick();
    }
  }, "Node Master"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#fff',
      fontSize: '12px',
      marginLeft: 13
    }
  }, version && 'v' + version)))), logoModalVisible && /*#__PURE__*/React.createElement(Upload, {
    visible: logoModalVisible,
    setVisible: setLogoModalVisible,
    showLogo: showLogo,
    refresh: getResourceQueryRun,
    logo: logo
  }), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, visible && /*#__PURE__*/React.createElement(Pwd, {
    visible: visible,
    setVisible: setVisible
  }), ketVisible && /*#__PURE__*/React.createElement(KeyModal, {
    visible: ketVisible,
    setVisible: setKetVisible
  }), /*#__PURE__*/React.createElement("li", {
    className: styles.lang_right
  }, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null)
    }),
    options: [{
      label: '中文',
      value: 'zh-CN'
    }, {
      label: 'English',
      value: 'en-US'
    }],
    getPopupContainer: t => t?.parentElement,
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: 'br'
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      changeLang(value);
      // Message.info(`${nextLang['message.lang.tips']}${value}`);
    }
  })), /*#__PURE__*/React.createElement("li", {
    style: {
      paddingRight: '20px',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(_Trigger, {
    trigger: "hover",
    position: "bottom",
    popupAlign: {
      bottom: [0, 12]
    },
    popup: () => droplist
  }, /*#__PURE__*/React.createElement(_Avatar, {
    size: 32,
    style: {
      backgroundColor: 'rgb(var(--primary-6))'
    }
  }, /*#__PURE__*/React.createElement(_IconUser, null)), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '10px',
      color: '#fff',
      fontSize: '14px',
      verticalAlign: 'middle'
    }
  }, userName, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      marginLeft: 2
    }
  }, "(", userInfo?.levelName, ")"))))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'none'
    }
  }));
}
export default Navbar;